import SvgIcon from './SvgIcon';

export default function AvatarIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <defs>
        <linearGradient
          x1="50%"
          y1="2.12320743%"
          x2="50%"
          y2="96.6725572%"
          id="avatar-linearGradient-1">
          <stop stopColor="#B9DBF1" offset="0%" />
          <stop stopColor="#BAC6F7" offset="100%" />
        </linearGradient>
        <ellipse
          id="path-2"
          cx="12"
          cy="12.4444444"
          rx="7.55555556"
          ry="7.11111111"
        />
      </defs>
      <g
        id="People"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-1106.000000, -649.000000)"
        opacity="1">
        <g id="Responses" transform="translate(658.000000, 440.000000)">
          <g id="People" transform="translate(0.000000, 192.000000)">
            <g id="Group-2" transform="translate(448.000000, 17.000000)">
              <circle
                id="Oval-2"
                fill="url(#avatar-linearGradient-1)"
                opacity="0.340000004"
                cx="12"
                cy="12"
                r="12"
              />
              <mask id="mask-3" fill="white">
                <use href="#path-2" />
              </mask>
              <g id="Mask" opacity="0.600000024" />
              <g mask="url(#mask-3)" fill="#7393BE" fillRule="nonzero">
                <g transform="translate(5.333333, 8.000000)">
                  <path
                    d="M13.2710764,13.6618148 L12.0900674,8.48125461 C11.8437616,7.39930713 10.9184071,6.48548712 9.89524949,6.22222222 C9.1450058,7.25063083 7.97927849,7.91370402 6.66648688,7.91370402 C5.35369527,7.91370402 4.18832753,7.25063083 3.43808384,6.22222222 C2.41456663,6.48548712 1.48975151,7.39930713 1.24290641,8.48125461 L0.0622569289,13.6618148 C-0.230972751,14.9479033 0.540126021,16 1.77578978,16 L11.5575436,16 C12.7932073,16 13.5643061,14.9479033 13.2710764,13.6618148 Z"
                    id="Shape"
                  />
                  <circle
                    id="Oval"
                    cx="6.66666667"
                    cy="3.11111111"
                    r="3.11111111"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
